var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRunning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8C11.7341 8 11.4734 8.02608 11.2204 8.07611L11.3175 8.56661L11.5115 9.5476L11.6086 10.0381C11.7344 10.0132 11.8651 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C11.8651 14 11.7344 13.9868 11.6086 13.9619L11.5115 14.4524L11.3175 15.4334L11.2204 15.9239C11.4734 15.9739 11.7341 16 12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8ZM9.77683 8.67434C9.34106 8.96608 8.96608 9.34106 8.67434 9.77683L9.08982 10.055L9.92079 10.6113L10.3363 10.8895C10.4826 10.6709 10.6709 10.4826 10.8895 10.3363L10.6113 9.92079L10.055 9.08982L9.77683 8.67434ZM8.07611 11.2204C8.02608 11.4734 8 11.7341 8 12C8 12.2659 8.02608 12.5266 8.07611 12.7796L8.56661 12.6825L9.5476 12.4885L10.0381 12.3914C10.0132 12.2656 10 12.1349 10 12C10 11.8651 10.0132 11.7344 10.0381 11.6086L9.5476 11.5115L8.56661 11.3175L8.07611 11.2204ZM8.67434 14.2232C8.96608 14.6589 9.34106 15.0339 9.77683 15.3257L10.055 14.9102L10.6113 14.0792L10.8895 13.6637C10.6709 13.5174 10.4826 13.3291 10.3363 13.1105L9.92079 13.3887L9.08982 13.945L8.67434 14.2232Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunning);
export default ForwardRef;